import { render, staticRenderFns } from "./Table_ia.vue?vue&type=template&id=a263c4e6&"
import script from "./Table_ia.vue?vue&type=script&lang=js&"
export * from "./Table_ia.vue?vue&type=script&lang=js&"
import style0 from "./Table_ia.vue?vue&type=style&index=0&id=a263c4e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports